export async function extractBlobError(err: any, fallback: string): Promise<string> {
  try {
    if (err?.response?.data instanceof Blob) {
      const text = await err.response.data.text();
      const parsed = JSON.parse(text);
      return parsed?.detail || fallback;
    }
    return err?.response?.data?.detail || fallback;
  } catch {
    return fallback;
  }
}
